
import React, { useEffect } from "react";
import Rune from "./Rune";
import { PhonemPair } from "./TunicIdeogram";
import { Config } from "../App";

interface GliphInput {
    phonems: Array<PhonemPair>
    config: Config
}

export default function Gliph(input: GliphInput) {

    return <span>
        {
            input.phonems.map((gliph, index) => <Rune
                key={index + "_" + gliph.vowel + "_" + gliph.consonant}
                color={input.config.color}
                width={input.config.glyphWidth+"px"}
                height={input.config.glyphHeight+"px"}
                strokeSize={input.config.strokeSize}
                vowel={gliph.vowel}
                consonant={gliph.consonant}
                dot={gliph.vowelfirst} />)
        }
    </span>


}
